import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import styles from "./layout.module.css";
import Header from "./Header";
import { NavigationTree } from "./NavigationTree";
import { useAppContext } from "Context/AppContext";
import { Homeless } from "Pages";
import { PageLoading } from "Components";
import Note from "./SideBar/Components/Note";
import SideBar from "./SideBar/SideBar";

interface MainLayoutProps {
  children: React.ReactElement;
  navKey?: string;
  subNavKey?: string;
  subSubNavKey?: string;
}

export default function MainLayout({
  children,
  navKey,
  subNavKey,
  subSubNavKey,
}: MainLayoutProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { orgList, currentOrg, showNoteApp, showSideBar } = useAppContext();

  useEffect(() => {
    if (!localStorage.getItem("email")) navigate("/login");
  }, [navigate]);

  if (!localStorage.getItem("email")) return <div></div>;
  if (!orgList) return <PageLoading />;

  const shouldShowNavigation = location.pathname !== "/create-organization";

  return (
    // main_layout
    <div className={styles.main_layout}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: showNoteApp ? "1fr 300px" : "1fr",
          width: "100%",
        }}
      >
        {/* header & noteApp*/}
        <div
          style={{
            gridColumn: 1,
          }}
        >
          <Header />
          {/* sideber & content */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: showSideBar ? "1fr 60px" : "1fr",
              width: "100%",
              position: "relative",
            }}
          >
            <div
              style={{
                gridColumn: 1,
              }}
            >
              <div className={styles.behind_header} />
              {shouldShowNavigation && (
                <NavigationTree
                  navKey={navKey}
                  subNavKey={subNavKey}
                  subSubNavKey={subSubNavKey}
                />
              )}
              {/* <div className={styles.content}>
                {currentOrg ? children : <Homeless />}
              </div> */}
              <div className={styles.content}>
                {location.pathname.startsWith("/my-account") ? children : (currentOrg ? children : <Homeless />)}
              </div>
            </div>
            {showSideBar && (
              <div
                style={{
                  gridColumn: 2,
                  backgroundColor: "#fbfbfb",
                  height: "100vh",
                  width: 60,
                  display: showSideBar ? "block" : "none",
                  paddingTop: 50,
                  position: "fixed",
                  right: showNoteApp ? 300 : 0,
                  top: 0,
                }}
              >
                <SideBar />
              </div>
            )}
          </div>
        </div>
        {showNoteApp && (
          <div
            style={{
              gridColumn: 2,
              backgroundColor: "#fff",
              height: "100vh",
              width: 300,
              display: showNoteApp ? "block" : "none",
              position: "fixed",
              right: 0,
              top: 0,
            }}
          >
            <Note />
          </div>
        )}
      </div>
    </div>
  );
}
